import { INBOX_TYPES } from 'shared/mixins/inboxMixin';
import { format } from 'date-fns-tz';

const MESSAGE_TEMPLATES_LANGUAGES_LABELS = {
  'pt-PT': 'pt',
  pt_PT: 'pt',
};

const TRANSLATION_STATUS = {
  APPROVED: 'approved',
  DRAFT: 'draft',
  PENDING: 'pending',
  SUBMITTED: 'submitted',
  REJECTED: 'rejected',
};

const TRANSLATION_STATUS_EDITABLE = [
  TRANSLATION_STATUS.DRAFT,
  TRANSLATION_STATUS.REJECTED,
];

const MESSAGE_TEMPLATES_STATUSES_OPTION = {
  [TRANSLATION_STATUS.PENDING]: {
    title: 'CHATLYN_MESSAGE_TEMPLATE.LIST.STATUSES.PENDING_APPROVAL',
    color: 'var(--yellow-500)',
  },
  [TRANSLATION_STATUS.APPROVED]: {
    title: 'CHATLYN_MESSAGE_TEMPLATE.LIST.STATUSES.APPROVED',
    color: 'var(--green-400)',
  },
  [TRANSLATION_STATUS.DRAFT]: {
    title: 'CHATLYN_MESSAGE_TEMPLATE.LIST.STATUSES.DRAFT',
    color: 'var(--gray-300)',
  },
  [TRANSLATION_STATUS.REJECTED]: {
    title: 'CHATLYN_MESSAGE_TEMPLATE.LIST.STATUSES.REJECTED',
    color: 'var(--red-500)',
  },
  [TRANSLATION_STATUS.SUBMITTED]: {
    title: 'CHATLYN_MESSAGE_TEMPLATE.LIST.STATUSES.SUBMITTED',
    color: 'var(--white)',
  },
};

const MESSAGE_TEMPLATES_CHANNEL_TYPE = {
  UNIVERSAL: 'universal',
  SMS: 'sms',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
};

const MESSAGE_TEMPLATES_CHANNEL_TYPE_BY_INBOX_TYPE = {
  [INBOX_TYPES.SMS]: MESSAGE_TEMPLATES_CHANNEL_TYPE.SMS,
  [INBOX_TYPES.WHATSAPP]: MESSAGE_TEMPLATES_CHANNEL_TYPE.WHATSAPP,
  [INBOX_TYPES.TELEGRAM]: MESSAGE_TEMPLATES_CHANNEL_TYPE.TELEGRAM,
};

const MESSAGE_TEMPLATES_CHANNEL_TYPES_MENU_ITEM = {
  [MESSAGE_TEMPLATES_CHANNEL_TYPE.UNIVERSAL]: {
    id: 'channel-type-universal',
    title: 'CHATLYN_MESSAGE_TEMPLATE.CHANNEL_TYPES.UNIVERSAL',
    icon: 'text-box',
  },
  [MESSAGE_TEMPLATES_CHANNEL_TYPE.SMS]: {
    id: 'channel-type-sms',
    title: 'CHATLYN_MESSAGE_TEMPLATE.CHANNEL_TYPES.SMS',
    icon: 'brand-sms',
  },
  [MESSAGE_TEMPLATES_CHANNEL_TYPE.WHATSAPP]: {
    id: 'channel-type-whatsapp',
    title: 'CHATLYN_MESSAGE_TEMPLATE.CHANNEL_TYPES.WHATSAPP',
    icon: 'brand-whatsapp',
  },
  [MESSAGE_TEMPLATES_CHANNEL_TYPE.TELEGRAM]: {
    id: 'channel-type-telegram',
    title: 'CHATLYN_MESSAGE_TEMPLATE.CHANNEL_TYPES.TELEGRAM',
    icon: 'brand-telegram',
  },
};

const TEMPLATE_BUILDER_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  DUPLICATE: 'duplicate',
};

// https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/supported-languages/
const MESSAGE_TEMPLATE_AVAILABLE_TRANSLATION_LANGUAGE = [
  'en',
  'de',
  'fr',
  'it',
  'es',
  'ca',
  'ar',
  'nl',
  'hu',
  'pl',
  'pt',
  'ro',
  'ru',
  // 'sr',
  'sk',
  'sl',
  'he',
  'tr',
];

const DATE_FORMAT = ['DD/MM/YYYY', 'D.M.YYYY', 'D.M.'];
const TIME_FORMAT = ['HH:mm', 'h:mm a'];

const DATE_FORMAT_FNS_FORMAT = {
  'DD/MM/YYYY': 'dd/MM/yyyy',
  'D.M.YYYY': 'd.M.yyyy',
  'D.M.': 'd.M.',
};

const GET_DATE_FORMAT_EXAMPLE = (date) => {
  const example = {};

  DATE_FORMAT.forEach((dateFormat) => {
    example[dateFormat] = format(date, DATE_FORMAT_FNS_FORMAT[dateFormat]);
  });

  return example;
};

const GET_TIME_FORMAT_EXAMPLE = (date) => {
  const example = {};

  TIME_FORMAT.forEach((timeFormat) => {
    example[timeFormat] = format(date, timeFormat);
  });

  return example;
};

export {
  MESSAGE_TEMPLATES_LANGUAGES_LABELS,
  MESSAGE_TEMPLATES_STATUSES_OPTION,
  MESSAGE_TEMPLATES_CHANNEL_TYPE,
  MESSAGE_TEMPLATES_CHANNEL_TYPE_BY_INBOX_TYPE,
  MESSAGE_TEMPLATES_CHANNEL_TYPES_MENU_ITEM,
  MESSAGE_TEMPLATE_AVAILABLE_TRANSLATION_LANGUAGE,
  DATE_FORMAT,
  TIME_FORMAT,
  TRANSLATION_STATUS,
  TRANSLATION_STATUS_EDITABLE,
  TEMPLATE_BUILDER_MODE,
  GET_DATE_FORMAT_EXAMPLE,
  GET_TIME_FORMAT_EXAMPLE,
};
